/* sucrase/dist/esm/parser/plugins/types.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    exports.typedParseConditional = typedParseConditional;
    exports.typedParseParenItem = typedParseParenItem;
    const index_1 = require("bfb18d0576") /* ../tokenizer/index */;
    const types_1 = require("f0c35cbd76") /* ../tokenizer/types */;
    const base_1 = require("540718e523") /* ../traverser/base */;
    const expression_1 = require("8178e7c3c8") /* ../traverser/expression */;
    const flow_1 = require("9b8d43cd0a") /* ./flow */;
    const typescript_1 = require("6a970c22b9") /* ./typescript */;
    /**
     * Common parser code for TypeScript and Flow.
     */
    // An apparent conditional expression could actually be an optional parameter in an arrow function.
    function typedParseConditional(noIn) {
        // If we see ?:, this can't possibly be a valid conditional. typedParseParenItem will be called
        // later to finish off the arrow parameter. We also need to handle bare ? tokens for optional
        // parameters without type annotations, i.e. ?, and ?) .
        if ((0, index_1.match)(types_1.TokenType.question)) {
            const nextType = (0, index_1.lookaheadType)();
            if (nextType === types_1.TokenType.colon || nextType === types_1.TokenType.comma || nextType === types_1.TokenType.parenR) {
                return;
            }
        }
        (0, expression_1.baseParseConditional)(noIn);
    }
    // Note: These "type casts" are *not* valid TS expressions.
    // But we parse them here and change them when completing the arrow function.
    function typedParseParenItem() {
        (0, index_1.eatTypeToken)(types_1.TokenType.question);
        if ((0, index_1.match)(types_1.TokenType.colon)) {
            if (base_1.isTypeScriptEnabled) {
                (0, typescript_1.tsParseTypeAnnotation)();
            }
            else if (base_1.isFlowEnabled) {
                (0, flow_1.flowParseTypeAnnotation)();
            }
        }
    }
}
